export interface Scripts {
    name: string;
    src: string;
}